var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.589 0 0 3.589 0 8C0 12.411 3.589 16 8 16C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM13.191 7.208L10.951 9.504L11.481 12.752C11.4958 12.8445 11.4844 12.9393 11.4479 13.0255C11.4115 13.1118 11.3516 13.1862 11.275 13.24C11.1983 13.2939 11.1081 13.3252 11.0146 13.3303C10.9211 13.3354 10.828 13.3142 10.746 13.269L8 11.753L5.255 13.271C5.17298 13.3171 5.07957 13.3391 4.98559 13.3343C4.89161 13.3295 4.80091 13.2982 4.72399 13.244C4.64707 13.1898 4.58709 13.1149 4.55098 13.028C4.51488 12.9411 4.50414 12.8458 4.52 12.753L5.05 9.505L2.81 7.209C2.74629 7.14307 2.7019 7.06093 2.68164 6.97152C2.66139 6.88211 2.66606 6.78885 2.69515 6.70191C2.72423 6.61497 2.77661 6.53767 2.84659 6.47845C2.91656 6.41922 3.00145 6.38032 3.092 6.366L6.168 5.896L7.548 2.956C7.713 2.605 8.288 2.605 8.453 2.956L9.833 5.896L12.909 6.366C12.9996 6.38012 13.0845 6.41886 13.1545 6.47798C13.2245 6.5371 13.277 6.61434 13.3061 6.70124C13.3352 6.78814 13.3398 6.88137 13.3195 6.97074C13.2992 7.06011 13.2548 7.14219 13.191 7.208Z",
    fill: "#F99806"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarYellow);
export default __webpack_public_path__ + "static/media/star-yellow.77ea7edf7ed1a2fcdb3cdd98249ba5bc.svg";
export { ForwardRef as ReactComponent };